<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @edit-btn="editBtn"
            @enable-btn="enableBtn"
            @disable-btn="disableBtn"
            @selectChange="selectChange"
            searchId="limitLineAreas"
            pageID="limitLineAreas"
            class="limit-line-areas"
        >
        <span slot="search-list-advance-right">
            <el-button class="reset"  @click="reset">重 置</el-button>
        </span>
        <div slot="table-module-btn">
            <el-tooltip effect="dark" content="导入" placement="bottom" >
                 <span v-has="'11070001'" class="mgl-10">
                    <el-button  icon="icon-daoru" size="mini" @click="orderImportC" ></el-button>
                 </span>
            </el-tooltip>
            <reportExport #default="{ submit }" reportCode="REPORT_OTP_LIMIT_LINE_AREAS">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <span v-has="'11070002'" class="mgl-10">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                    </span>
                </el-tooltip>
            </reportExport>
      </div>
      <div slot="page-module-btn">
          <el-button type="primary" @click="addBtn" v-has="'11070003'">新 增</el-button>
          <el-button type="primary" @click="delBtn" v-has="'11070004'">删 除</el-button>
      </div>
        </m-pane>
          <edit-dialog v-if="editDialogVisible"  :dialogVisible.sync="editDialogVisible"  :title="title"
          :rowData="rowData" @handleClose="handleClose"></edit-dialog>
            <!-- 文件上传 -->
        <import ref="Import" :ImportConfig="config.ImportConfig" :ImportContent="config.ImportContent" @reflashList="getList"></import>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import EditDialog from './EditDialog';
import Import from '../../../components/import/import';
import reportExport from '@/components/lots/reportExportPlugin';
import { getSearchList, deleteByIds, editDate } from '../../../api/limitLineAreas';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    name: 'limitLineAreas',
    components: { mPane, paper, EditDialog, Import, reportExport },
    data() {
        return {
            config: config,
            totalData: [],
            selectData: [],
            loading: false,
            editDialogVisible: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            title: '新增',
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                orderBy: 'updateTime',
                orderByType: 'desc'
            },
            rowData: {},
            isFirstSearch: true
        };
    },
    methods: {
        // 重置查询参数
        reset() {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        },
        selectChange(data) {
            this.selectData = data;
        },
        addBtn() {
            this.title = '新增';
            this.editDialogVisible = true;
        },
        editBtn(rowData) {
            this.title = '编辑';
            this.rowData = rowData;
            this.editDialogVisible = true;
        },
        handleClose(val) {
            if (val) {
                this.getList();
            }
            this.editDialogVisible = false;
        },
        getList() {
            this.isFirstSearch = false;
            this.loading = true;
            getSearchList(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.totalData.forEach(item => {
                        item.hiddenEvent = [];
                        if (+item.limitStatus === 0) {
                            item.limitStatusName = '启用';
                            item.hiddenEvent = ['edit', 'enable'];
                        } else {
                            item.limitStatusName = '停用';

                            item.hiddenEvent = ['disable'];
                        }
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        delBtn() {
            if (!this.selectData.length) {
                return this.$message.warning('请先勾选数据!');
            }
            let delCheck = 0;
            delCheck = (this.selectData.filter(item => +item.limitStatus === 0)).length;
            if (delCheck) {
                return this.$message.warning('存在启用的数据,不允许删除!');
            }
            this.$confirm('请确认是否删除选中数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let ids = [];
                ids = this.selectData.map(item => item.id);
                deleteByIds(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        enableBtn(rowData) {
            rowData.limitStatus = 0;
            this.handleSave(rowData, '启用成功');
        },
        disableBtn(rowData) {
            rowData.limitStatus = 1;
            this.handleSave(rowData, '停用成功');
        },
        handleSave(rowData, message) {
            editDate(rowData, rowData.id).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(`${message}`);
                    this.getList();
                }
            });
        },
        // 获取下载模板路径
        async  getDictList() {
            if (!this.config.ImportContent[0].downLoadInfo.url) {
                const dict = await dictWithUrl('ANNTO_FORMWORK_OTP');
                this.config.ImportContent[0].downLoadInfo.url =
                       dict.data.ANNTO_FORMWORK_OTP.LIMIT_LINE_AREAS;
            }
        },
        // 导入
        orderImportC() {
            this.getDictList();
            this.$refs.Import.orderImportC();
        },
        // 导出
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams,
                beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                endDate2: '2030-11-11 00:00:00'
            });
            this.isFirstSearch = false;
        },
        searchChange (data) {
            this.searchParams.pageNo = 1;
            if (data.addressCode.length) {
                [data.provinceCode, data.cityCode, data.districtCode] = data.addressCode;
            } else {
                data.provinceCode = '';
                data.cityCode = '';
                data.districtCode = '';
            }
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        }
    },
    mounted() {
        this.getList();
    }
};
</script>
<style scoped lang="less">
.limit-line-areas{
    .reset{
        margin-left: 10px;
    }
}
</style>
